import React from "react";

type Feature = {
  heading: string;
  desc: string;
  icon: string;
};

type FeaturesShowCaseCardsProps = {
  data: Feature[];
};

const FeaturesShowCaseCards = ({ data }: FeaturesShowCaseCardsProps) => {
  const List = () => {
    let theClasses: string | undefined;
    let className;
    if (data.length === 3) {
      theClasses = "has-three-col";
    }
    if (data.length === 4) {
      theClasses = "has-three-col";
    }
    if (data.length > 4) {
      theClasses = "has-three-col";
      className = "lg:mb-5";
    }
    return (
      <ul
        className={`container card--default card--feature has-shadow ${theClasses}`}
      >
        {data.map((item, count) => {
          let { heading, desc, icon } = item;
          return (
            <li className={`bg-white ${className}`} key={count}>
              <div className="icon-title-wrap">
                <figure dangerouslySetInnerHTML={{ __html: icon }}></figure>
                <h3
                  className="lg:mt-3 lg:mb-3"
                  dangerouslySetInnerHTML={{
                    __html: heading,
                  }}
                />
              </div>
              <p dangerouslySetInnerHTML={{ __html: desc }} />
            </li>
          );
        })}
      </ul>
    );
  };
  return <List />;
};

export default FeaturesShowCaseCards;
